<script>
import { api } from "@/state/services";

export default {
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
    client: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    show: {
      get() {
        return this.modal;
      },
      set(value) {
        this.$emit("update:modal", value);
      },
    },
  },
  methods: {
    sendDocument() {
      this.loading = true;

      api
        .post('exclusaoindividual/clients/documents/send', { id: this.client.id, type: this.type })
        .then((response) => {
          if (response.data.status === 'success') {
            this.$toast.success('Link de assinatura gerado!');

            this.loading = false;
            this.show = false;

            this.$emit('sent');
          } else {
            this.$toast.error(response.data.message);
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    docLabel(type) {
      const labels = {
        ficha_associativa:   'Ficha Associativa',
        autorizacao_processo:'Autorização de Processo',
        contrato_social:     'Contrato Social',
        cartao_cnpj:         'Cartão CNPJ',
        doc_foto:            'Documento com Foto',
      };
      return labels[type] || type;
    },
  },
};
</script>

<template>
  <b-modal v-model="show" modal-class="modal-bottom" hide-footer hide-header>
    <div class="px-3">
      <h5 class="mb-4" v-if="type">Deseja gerar o link de assinatura de <strong>{{ docLabel(type) }}</strong> do cliente <span class="bg-soft-dark px-2 rounded text-uppercase">{{ client.name }}</span>?</h5>
      <div class="mt-4 d-flex justify-content-between">
        <b-button class="btn-lg" variant="default" :disabled="loading" v-on:click="sendDocument()">
          Gerar
          <b-spinner v-if="loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
        </b-button>
        <b-button class="text-dark text-decoration-none" variant="link" v-on:click="show = false">Fechar</b-button>
      </div>
    </div>
  </b-modal>
</template>

<style scoped>
button:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}
</style>
